// src/utils/logtail-browser.ts
import { Logtail } from "@logtail/browser";

const logtail = new Logtail(process.env.GATSBY_LOGTAIL_SOURCE_TOKEN!, {
    endpoint: "https://s1519162.eu-nbg-2.betterstackdata.com", // optional
});

export default logtail;